var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":"","dense":""}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"name-phone-address s-vstack"},[_c('Name'),_c('Access'),_c('Phone'),(_vm.showAddress)?_c('Address'):_vm._e(),(_vm.hasDish)?_c('Note'):_vm._e()],1)]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('Map')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }